import { Bell, ChevronDown, Coins, FolderKanban, Home, Moon, Sun, User, Users } from 'lucide-react'
import { useState } from 'react'

export default function ThemeDemo() {
  const [activeTab, setActiveTab] = useState('current')
  const [theme, setTheme] = useState<'dark' | 'light'>('dark')

  const toggleTheme = () => {
    setTheme(theme === 'dark' ? 'light' : 'dark')
    document.body.classList.toggle('light')
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--body-bg)',
      color: 'var(--text-primary)',
      padding: '20px'
    }}>
      {/* Header */}
      <div style={{
        background: 'var(--card-bg)',
        border: '1px solid var(--border-default)',
        borderRadius: '12px',
        padding: '24px',
        marginBottom: '20px'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h1 style={{
              fontFamily: 'var(--font-heading)',
              fontSize: '32px',
              fontWeight: 700,
              marginBottom: '8px'
            }}>
              Tema Karşılaştırma
            </h1>
            <p style={{ color: 'var(--text-secondary)', fontSize: '14px' }}>
              Mevcut sistem vs Metronic UI Framework
            </p>
          </div>
          <button
            onClick={toggleTheme}
            style={{
              background: 'var(--card-bg)',
              border: '1px solid var(--border-default)',
              borderRadius: '8px',
              padding: '12px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              color: 'var(--text-primary)'
            }}
          >
            {theme === 'dark' ? <Sun size={20} /> : <Moon size={20} />}
            {theme === 'dark' ? 'Light' : 'Dark'}
          </button>
        </div>
      </div>

      {/* Tab Navigation */}
      <div style={{
        display: 'flex',
        gap: '8px',
        marginBottom: '20px',
        borderBottom: '1px solid var(--border-default)',
        paddingBottom: '0'
      }}>
        <button
          onClick={() => setActiveTab('current')}
          style={{
            background: activeTab === 'current' ? 'var(--active-bg)' : 'transparent',
            border: 'none',
            borderBottom: activeTab === 'current' ? '2px solid var(--primary)' : '2px solid transparent',
            padding: '12px 24px',
            cursor: 'pointer',
            color: activeTab === 'current' ? 'var(--text-primary)' : 'var(--text-secondary)',
            fontWeight: activeTab === 'current' ? 600 : 400,
            fontSize: '14px'
          }}
        >
          Mevcut Sistem
        </button>
        <button
          onClick={() => setActiveTab('metronic')}
          style={{
            background: activeTab === 'metronic' ? 'var(--active-bg)' : 'transparent',
            border: 'none',
            borderBottom: activeTab === 'metronic' ? '2px solid var(--primary)' : '2px solid transparent',
            padding: '12px 24px',
            cursor: 'pointer',
            color: activeTab === 'metronic' ? 'var(--text-primary)' : 'var(--text-secondary)',
            fontWeight: activeTab === 'metronic' ? 600 : 400,
            fontSize: '14px'
          }}
        >
          Metronic UI
        </button>
        <button
          onClick={() => setActiveTab('comparison')}
          style={{
            background: activeTab === 'comparison' ? 'var(--active-bg)' : 'transparent',
            border: 'none',
            borderBottom: activeTab === 'comparison' ? '2px solid var(--primary)' : '2px solid transparent',
            padding: '12px 24px',
            cursor: 'pointer',
            color: activeTab === 'comparison' ? 'var(--text-primary)' : 'var(--text-secondary)',
            fontWeight: activeTab === 'comparison' ? 600 : 400,
            fontSize: '14px'
          }}
        >
          Karşılaştırma
        </button>
      </div>

      {/* Content */}
      {activeTab === 'current' && <CurrentSystemDemo />}
      {activeTab === 'metronic' && <MetronicDemo />}
      {activeTab === 'comparison' && <ComparisonDemo />}
    </div>
  )
}

// Mevcut sistem demo
function CurrentSystemDemo() {
  return (
    <div style={{ display: 'grid', gap: '20px' }}>
      {/* Topbar Demo */}
      <div style={{
        background: 'var(--card-bg)',
        border: '1px solid var(--border-default)',
        borderRadius: '12px',
        padding: '24px'
      }}>
        <h3 style={{
          fontFamily: 'var(--font-heading)',
          fontSize: '18px',
          fontWeight: 700,
          marginBottom: '16px'
        }}>
          Topbar (Mevcut)
        </h3>
        <div style={{
          background: 'var(--surface)',
          border: '1px solid var(--border-default)',
          borderRadius: '8px',
          padding: '12px 20px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          {/* Left */}
          <div style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Home size={20} />
              <span style={{ fontSize: '14px' }}>Ask AI</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Users size={20} />
              <span style={{ fontSize: '14px' }}>FlzHub</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Coins size={20} />
              <span style={{ fontSize: '14px' }}>Token</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <FolderKanban size={20} />
              <span style={{ fontSize: '14px' }}>Project</span>
            </div>
          </div>

          {/* Right */}
          <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
            <div style={{
              background: 'rgba(16, 185, 129, 0.15)',
              color: 'var(--green)',
              padding: '4px 12px',
              borderRadius: '20px',
              fontSize: '12px',
              fontWeight: 600,
              display: 'flex',
              alignItems: 'center',
              gap: '6px'
            }}>
              <div style={{
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                background: 'var(--green)',
                animation: 'pulse 2s infinite'
              }} />
              CANLI
            </div>
            <Bell size={20} />
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <div style={{
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                background: 'var(--primary)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '14px',
                fontWeight: 600
              }}>
                U
              </div>
              <ChevronDown size={16} />
            </div>
          </div>
        </div>
      </div>

      {/* Cards Demo */}
      <div style={{
        background: 'var(--card-bg)',
        border: '1px solid var(--border-default)',
        borderRadius: '12px',
        padding: '24px'
      }}>
        <h3 style={{
          fontFamily: 'var(--font-heading)',
          fontSize: '18px',
          fontWeight: 700,
          marginBottom: '16px'
        }}>
          Cards (Mevcut)
        </h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '16px' }}>
          {[
            { title: 'Toplam Projeler', value: '1,234', color: 'var(--accent-blue)' },
            { title: 'Aktif Agentlar', value: '567', color: 'var(--green)' },
            { title: 'FLZ Token', value: '89.5K', color: 'var(--yellow)' },
            { title: 'Kazanç', value: '$12.3K', color: 'var(--purple)' }
          ].map((item, i) => (
            <div key={i} style={{
              background: 'var(--surface)',
              border: '1px solid var(--border-default)',
              borderRadius: '8px',
              padding: '16px'
            }}>
              <div style={{ fontSize: '12px', color: 'var(--text-secondary)', marginBottom: '8px' }}>
                {item.title}
              </div>
              <div style={{ fontSize: '24px', fontWeight: 700, color: item.color }}>
                {item.value}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Buttons Demo */}
      <div style={{
        background: 'var(--card-bg)',
        border: '1px solid var(--border-default)',
        borderRadius: '12px',
        padding: '24px'
      }}>
        <h3 style={{
          fontFamily: 'var(--font-heading)',
          fontSize: '18px',
          fontWeight: 700,
          marginBottom: '16px'
        }}>
          Buttons (Mevcut)
        </h3>
        <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
          <button className="btn btn-primary">Primary</button>
          <button className="btn btn-secondary">Secondary</button>
          <button className="btn btn-success">Success</button>
          <button className="btn btn-danger">Danger</button>
          <button className="btn btn-warning">Warning</button>
          <button className="btn btn-ghost">Ghost</button>
        </div>
      </div>
    </div>
  )
}

// Metronic UI demo
function MetronicDemo() {
  return (
    <div style={{ display: 'grid', gap: '20px' }}>
      {/* Info Card */}
      <div style={{
        background: 'var(--card-bg)',
        border: '1px solid var(--border-default)',
        borderRadius: '12px',
        padding: '24px'
      }}>
        <div style={{
          background: 'rgba(6, 182, 212, 0.1)',
          border: '1px solid rgba(6, 182, 212, 0.3)',
          borderRadius: '8px',
          padding: '16px',
          display: 'flex',
          gap: '12px',
          alignItems: 'flex-start'
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            borderRadius: '8px',
            background: 'rgba(6, 182, 212, 0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0
          }}>
            <Home size={20} style={{ color: 'var(--info)' }} />
          </div>
          <div>
            <h4 style={{ fontSize: '16px', fontWeight: 600, marginBottom: '4px' }}>
              Metronic UI Framework
            </h4>
            <p style={{ fontSize: '14px', color: 'var(--text-secondary)', lineHeight: 1.6 }}>
              Metronic v9.4.6 Tailwind + React + TypeScript kullanıyor.
              Hazır component&apos;ler, daha temiz kod, daha hızlı geliştirme.
            </p>
          </div>
        </div>
      </div>

      {/* Metronic Style Cards */}
      <div style={{
        background: 'var(--card-bg)',
        border: '1px solid var(--border-default)',
        borderRadius: '12px',
        padding: '24px'
      }}>
        <h3 style={{
          fontFamily: 'var(--font-heading)',
          fontSize: '18px',
          fontWeight: 700,
          marginBottom: '16px'
        }}>
          Cards (Metronic Style)
        </h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '16px' }}>
          {[
            { title: 'Total Revenue', value: '$45.2K', change: '+12.5%', icon: Coins, color: 'var(--success)' },
            { title: 'Active Users', value: '8,282', change: '+3.1%', icon: Users, color: 'var(--info)' },
            { title: 'Projects', value: '1,234', change: '+8.2%', icon: FolderKanban, color: 'var(--warning)' },
            { title: 'Agents', value: '567', change: '+15.3%', icon: User, color: 'var(--purple)' }
          ].map((item, i) => (
            <div key={i} style={{
              background: 'var(--surface)',
              border: '1px solid var(--border-default)',
              borderRadius: '12px',
              padding: '20px',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <div style={{
                position: 'absolute',
                top: '-10px',
                right: '-10px',
                width: '80px',
                height: '80px',
                borderRadius: '50%',
                background: `${item.color}15`,
                filter: 'blur(20px)'
              }} />
              <div style={{ position: 'relative', zIndex: 1 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                  <div style={{ fontSize: '13px', color: 'var(--text-secondary)', fontWeight: 500 }}>
                    {item.title}
                  </div>
                  <div style={{
                    width: '36px',
                    height: '36px',
                    borderRadius: '8px',
                    background: `${item.color}20`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <item.icon size={18} style={{ color: item.color }} />
                  </div>
                </div>
                <div style={{ fontSize: '28px', fontWeight: 700, marginBottom: '8px' }}>
                  {item.value}
                </div>
                <div style={{
                  fontSize: '12px',
                  color: item.color,
                  fontWeight: 600
                }}>
                  {item.change} this month
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

// Karşılaştırma
function ComparisonDemo() {
  return (
    <div style={{ display: 'grid', gap: '20px' }}>
      <div style={{
        background: 'var(--card-bg)',
        border: '1px solid var(--border-default)',
        borderRadius: '12px',
        padding: '24px'
      }}>
        <h3 style={{
          fontFamily: 'var(--font-heading)',
          fontSize: '18px',
          fontWeight: 700,
          marginBottom: '16px'
        }}>
          Karşılaştırma Tablosu
        </h3>
        <div style={{ overflow: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '2px solid var(--border-default)' }}>
                <th style={{ padding: '12px', textAlign: 'left', fontSize: '14px', fontWeight: 600 }}>Özellik</th>
                <th style={{ padding: '12px', textAlign: 'center', fontSize: '14px', fontWeight: 600 }}>Mevcut Sistem</th>
                <th style={{ padding: '12px', textAlign: 'center', fontSize: '14px', fontWeight: 600 }}>Metronic UI</th>
              </tr>
            </thead>
            <tbody>
              {[
                { feature: 'CSS Yaklaşımı', current: 'Inline styles + CSS variables', metronic: 'Tailwind CSS classes' },
                { feature: 'Component Library', current: 'Custom components', metronic: 'Metronic + Radix UI' },
                { feature: 'Dark/Light Theme', current: '✓ (CSS variables)', metronic: '✓ (Tailwind dark mode)' },
                { feature: 'Responsive', current: '✓ (Media queries)', metronic: '✓ (Tailwind breakpoints)' },
                { feature: 'Icons', current: 'lucide-react', metronic: 'lucide-react + Remixicon' },
                { feature: 'Kod Miktarı', current: 'Fazla (inline styles)', metronic: 'Az (utility classes)' },
                { feature: 'Geliştirme Hızı', current: 'Orta', metronic: 'Hızlı' },
                { feature: 'Öğrenme Eğrisi', current: 'Düşük', metronic: 'Orta (Tailwind)' },
                { feature: 'Bakım', current: 'Zor (inline styles)', metronic: 'Kolay (utility classes)' },
                { feature: 'Performans', current: 'İyi', metronic: 'Çok İyi (Tailwind JIT)' }
              ].map((row, i) => (
                <tr key={i} style={{ borderBottom: '1px solid var(--border-light)' }}>
                  <td style={{ padding: '16px', fontSize: '14px', fontWeight: 500 }}>{row.feature}</td>
                  <td style={{ padding: '16px', textAlign: 'center', fontSize: '13px', color: 'var(--text-secondary)' }}>{row.current}</td>
                  <td style={{ padding: '16px', textAlign: 'center', fontSize: '13px', color: 'var(--text-secondary)' }}>{row.metronic}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Öneriler */}
      <div style={{
        background: 'var(--card-bg)',
        border: '1px solid var(--border-default)',
        borderRadius: '12px',
        padding: '24px'
      }}>
        <h3 style={{
          fontFamily: 'var(--font-heading)',
          fontSize: '18px',
          fontWeight: 700,
          marginBottom: '16px'
        }}>
          Migration Önerileri
        </h3>
        <div style={{ display: 'grid', gap: '12px' }}>
          {[
            {
              title: '1. Tailwind CSS Kurulumu',
              desc: 'Metronic Tailwind config dosyasını kopyala, mevcut CSS variables ile entegre et',
              status: 'critical'
            },
            {
              title: '2. Component Migration',
              desc: 'Inline styles yerine Tailwind utility classes kullan',
              status: 'high'
            },
            {
              title: '3. Layout System',
              desc: 'Metronic layout component\'lerini kullan',
              status: 'high'
            },
            {
              title: '4. Theme System',
              desc: 'CSS variables + Tailwind dark mode birlikte kullan',
              status: 'medium'
            },
            {
              title: '5. Icon System',
              desc: 'lucide-react devam et',
              status: 'low'
            }
          ].map((item, i) => (
            <div key={i} style={{
              background: 'var(--surface)',
              border: '1px solid var(--border-default)',
              borderRadius: '8px',
              padding: '16px',
              display: 'flex',
              gap: '12px',
              alignItems: 'flex-start'
            }}>
              <div style={{
                width: '6px',
                height: '6px',
                borderRadius: '50%',
                background:
                  item.status === 'critical' ? 'var(--danger)' :
                  item.status === 'high' ? 'var(--warning)' :
                  item.status === 'medium' ? 'var(--info)' :
                  'var(--success)',
                marginTop: '6px',
                flexShrink: 0
              }} />
              <div>
                <div style={{ fontSize: '14px', fontWeight: 600, marginBottom: '4px' }}>
                  {item.title}
                </div>
                <div style={{ fontSize: '13px', color: 'var(--text-secondary)', lineHeight: 1.5 }}>
                  {item.desc}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
